import { caption, eyebrow, h2, h3, h5, mediaQueries } from '@/theme/lib';
import styled from 'styled-components';

import Pagination from '@/components/Pagination';

export const StyledSearchPage = styled.div`
  padding-bottom: 7.5rem;
  ${mediaQueries.lg} {
    padding-bottom: 12rem;
  }

  li {
    list-style: none;
  }
`;

export const StyledBackground = styled.div`
  background: ${(props) => props.theme.colors.primary};
`;

export const StyledTopWrapper = styled.div`
  grid-column: 1 / span 5;
  padding: 7.25rem 0 1.75rem;
  form {
    margin: 0;
  }
  ${mediaQueries.mdLogo} {
    padding-top: 10rem;
    padding-left: 1rem;
  }
  ${mediaQueries.lg} {
    grid-column: 2 / span 8;
    padding: 15.5rem 0 2.875rem;
  }

  h1,
  p {
    color: ${(props) => props.theme.colors.caption};
  }

  h1 {
    ${h2}
    text-transform: none;
    margin-bottom: 0.25rem;
  }

  p {
    ${h5}
    margin-bottom: 1.25rem;

    ${mediaQueries.lg} {
      margin-bottom: 1.5rem;
    }
  }
`;

export const StyledNoResultsWrapper = styled('div')<{ hasSuggestions: boolean }>`
  padding-top: 4.6rem;
  grid-column: 1 / span 5;
  position: relative;

  ${mediaQueries.lg} {
    grid-column: 2 / span 8;
    padding-top: ${(props) => props.hasSuggestions ? '8.25rem' : '15.75rem'};
  }

  p {
    text-align: center;
    ${h3}
    color: ${(props) => props.theme.colors.caption};
    z-index: 1;
    position: relative;
    z-index: 10;

    ${mediaQueries.lg} {
      font-weight: 400;
      span {
        font-weight: 600;
      }
    }
  }

  &::after {
    content: url(/SearchPage/eagle.png);
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);

    ${mediaQueries.lg} {
      display: none;
    }
  }
`;

export const StyledResultsWrapper = styled.section`
  margin-top: 2.5rem;
  grid-column: 1 / span 5;

  ${mediaQueries.lg} {
    margin-top: 5.75rem;
    grid-column: 2 / span 8;
  }
`;

export const StyledResultsTopWrapper = styled.div`
  h2 {
    ${h3}
    color: ${(props) => props.theme.colors.caption};

    ${mediaQueries.lg} {
      ${h2}
    }
  }

  p {
    ${caption}
    color: ${(props) => props.theme.colors.caption};
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
    font-size: 0.875rem;

    ${mediaQueries.md} {
      margin-bottom: 0;
    }

    ${mediaQueries.lg} {
      ${h5}
      margin-top: 1rem;
    }
  }

  ${mediaQueries.md} {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const StyledResultsList = styled.ul`
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  ${mediaQueries.md} {
    margin-top: 4rem;
    gap: 2.5rem;
  }

  .generic-card {
    max-width: 590px;

    ${mediaQueries.md} {
      max-width: none;
      flex-direction: row;
      gap: 2rem;
    }

    &__img-wrapper {
      & > span {
        display: block!important;
      }
      height: auto;
      aspect-ratio: 590/348;
      ${mediaQueries.md} {
        width: 25%;
        flex-grow: 0;
        flex-shrink: 0;
        height: 100%;
        display: block;
      }
    }

    &__text {
      ${mediaQueries.md} {
        flex: none;
        flex-grow: 1;
        flex-shrink: 1;

        a {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
        }
      }

      a svg {
        width: 2.5rem;
      }
    }
  }
`;

export const StyledPagination = styled(Pagination)`
  padding: 0;

  ${mediaQueries.lg} {
    margin-top: 8.75rem;
  }
`;

export const StyledDefaultWrapper = styled.section`
  margin-top: 2.5rem;
  grid-column: 1 / span 5;

  ${mediaQueries.lg} {
    grid-column: 2 / span 8;
    margin-top: 3.375rem;
  }

  h2 {
    ${eyebrow}
    margin-top: 0;
    color: ${(props) => props.theme.colors.caption};
  }

  ul {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.2rem;

    ${mediaQueries.lg} {
      flex-direction: row;
      gap: 1.5rem;
      margin-top: 1.25rem;
    }
  }
`;

// Search suggestions
export const SearchSuggestionsWrapper = styled.div`
  grid-column: 1 / span 5;
  margin-top: 2.5rem;
  ${mediaQueries.lg} {
    margin-top: 3.5rem;
    grid-column: 2 / span 8;
  }
  .suggestions-title {
    line-height: 120%;
    text-transform: uppercase;
    margin-bottom: 1rem;
    color: ${(props) => props.theme.colors.caption};
    ${mediaQueries.lg} {
      font-weight: 700;
      margin-bottom: 1.25rem;
      font-size: 1.125rem;
    }
  }
  .suggestions-wrapper {
    ${mediaQueries.lg} {
      gap: 1rem;
      display: flex;
      flex-flow: row wrap;
    }
  }
`;

export const SearchSuggestion = styled.div`
  margin-bottom: 0.5rem;
  text-transform: capitalize;
  ${mediaQueries.lg} {
    font-size: 1.25rem;
    margin-bottom: 0;
  }
`;